module.exports = __webpack_public_path__ + "media/images/mr6-b892baf05df0e17506d4a3f14cf1c704.jpg";